import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const toU8 = (b64) => { const p = "=".repeat((4 - (b64.length % 4)) % 4); const raw = atob((b64 + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...raw].map((c) => c.charCodeAt(0))); };

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isInstalled = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

// Abonnement push : uniquement l'adresse technique d'abonnement, l'heure et le décalage horaire. Aucune donnée clinique.
export async function subscribePush(kind, time) {
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await axios.get(`${API}/push/vapid-public-key`);
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toU8(data.key) });
  }
  await axios.post(`${API}/push/subscriptions`, { subscription: sub.toJSON(), time, tz_offset: -new Date().getTimezoneOffset(), kind });
  return true;
}

export async function unsubscribePush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  await axios.delete(`${API}/push/subscriptions`, { data: { endpoint: sub.endpoint } }).catch(() => {});
  await sub.unsubscribe().catch(() => {});
}
